/* 🤖 this file was generated by svg-to-ts */
export const DfIconBookmark12: {
  name: 'bookmark-12';
  data: string;
} = {
  name: 'bookmark-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M9 2.251v8.125a.613.613 0 0 1-.6.625.587.587 0 0 1-.41-.168L6.352 9.118a.581.581 0 0 0-.728.026l-1.614 1.69a.583.583 0 0 1-.848-.031.64.64 0 0 1-.161-.426V2.25c0-.69.537-1.25 1.2-1.25h3.6c.663 0 1.2.56 1.2 1.25z"/></svg>`
};
